import React from 'react';
import PropTypes from 'prop-types';
import PaymentMethodIcon, { ICON_TYPES } from '../PayManually/PaymentMethodIcon';
import styles from './CashLine.scss';
import { Text } from 'wix-style-react';

export default function CashLine({ block, className }) {
  return (
    <Text
      size="small"
      weight="normal"
      secondary
      tagName={block ? 'div' : 'span'}
      className={`${className} ${styles.text}`}
      data-hook="credit-card-line"
    >
      <PaymentMethodIcon type={ICON_TYPES.CASH} size={30} className={styles.svg} />
      Cash
    </Text>
  );
}

CashLine.displayName = 'CashLine';
CashLine.propTypes = {
  lastDigits: PropTypes.string,
  network: PropTypes.string,
  holderName: PropTypes.string,
  block: PropTypes.bool,
  locale: PropTypes.string,
  className: PropTypes.string,
};
